import { Link } from 'react-router-dom'
import type { ManagerActiveRequest } from './types'

function progressClass(percent: number): string {
  if (percent >= 100) return 'bg-emerald-500'
  if (percent >= 50) return 'bg-blue-500'
  return 'bg-amber-500'
}

function deadlineCellClass(req: ManagerActiveRequest): string {
  if (req.isOverdue) return 'text-red-600 font-semibold'
  if (req.isUrgent) return 'text-red-600 font-semibold'
  return 'text-gray-600'
}

export function ActiveRequestsTable({
  requests,
  onRowClick,
}: {
  requests: ManagerActiveRequest[]
  onRowClick?: (id: string) => void
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm text-gray-500">Мои активные заявки</div>
        <Link to="/requests" className="text-xs text-brand-600 hover:underline">
          Все →
        </Link>
      </div>

      {requests.length === 0 ? (
        <p className="text-sm text-gray-400 py-4">Нет активных заявок</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-xs text-gray-500">
                <th className="text-left font-normal pb-2">№ / Клиент</th>
                <th className="text-left font-normal pb-2">Статус</th>
                <th className="text-left font-normal pb-2 w-[30%]">Прогресс</th>
                <th className="text-right font-normal pb-2">Дедлайн</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((r) => {
                const row = (
                  <tr
                    key={r.id}
                    onClick={() => onRowClick?.(r.id)}
                    className={`border-t border-gray-100 ${
                      r.isUrgent || r.isOverdue ? 'bg-red-50/40' : ''
                    } ${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}`}
                  >
                    <td className="py-2">
                      <div className="font-mono text-xs text-gray-500">{r.number ?? '—'}</div>
                      <div className="text-gray-900 truncate max-w-[180px]">{r.clientName}</div>
                    </td>
                    <td className="py-2">
                      <span className="inline-block px-1.5 py-0.5 rounded bg-gray-100 text-xs text-gray-700">
                        {r.statusLabel}
                      </span>
                    </td>
                    <td className="py-2">
                      <div className="flex items-center gap-2">
                        <div className="flex-1 h-1.5 bg-gray-100 rounded overflow-hidden">
                          <div
                            className={`h-full ${progressClass(r.progressPercent)}`}
                            style={{ width: `${Math.min(100, r.progressPercent)}%` }}
                          />
                        </div>
                        <span className="text-xs text-gray-500 tabular-nums w-8 text-right">
                          {r.progressPercent}%
                        </span>
                      </div>
                    </td>
                    <td className={`py-2 text-right tabular-nums ${deadlineCellClass(r)}`}>
                      {r.deadlineLabel}
                    </td>
                  </tr>
                )
                return row
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
